import { render, staticRenderFns } from "./DimensionCard.vue?vue&type=template&id=793c991e&scoped=true"
import script from "./DimensionCard.vue?vue&type=script&lang=js"
export * from "./DimensionCard.vue?vue&type=script&lang=js"
import style0 from "./DimensionCard.vue?vue&type=style&index=0&id=793c991e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793c991e",
  null
  
)

export default component.exports